const initialState = {
  data: [],
  params: null,
  allData: [],
  allPartner: [],
  totalPages: 0,
  filteredData: [],
  totalRecords: 0,
  sortIndex: [],
  refresh: 0,
  connectorNameRes: {},
  modalData: {
    emableModel: false,
    message: "",
    enableCancleButton: true,
    enableOkButton: true,
    headerMsg: ""
  },
  modalEmail: {
    emableModel: false,
    enableOkButton: true,
  },
  testGdriveRes: {},
  testEmailRes: {},
  modalWorkqueue: {
    emableModel: false,
    enableOkButton: true,
  },
  modalGdriveSuccess: {
    emableModel: false,
    enableOkButton: true,
  },
  modalUnauthenticated: {
    emableModel: false,
    enableOkButton: true,
  },
  modalMailFailureExport: {
    emableModel: false,
    enableOkButton: true,
  },
  modalEmailFailed: {
    emableModel: false,
    enableOkButton: true,
  },
  modalNotActive: {
    emableModel: false,
    enableOkButton: true,
  },
  addResponse: "",
  updateResponse: "",
  isActive: false,

  tableLoading: false,
  sidebarLoading: false
}

// const moveIndex = (arr, from, to) => {
//   let el = arr[from]
//   arr.splice(from, 1)
//   arr.splice(to, 0, el)
// }

const getIndex = (arr, arr2, arr3, params = {}) => {
  if (arr2.length > 0) {
    let startIndex = arr.findIndex(i => i.id === arr2[0].id) + 1
    let endIndex = arr.findIndex(i => i.id === arr2[arr2.length - 1].id) + 1
    let finalArr = [startIndex, endIndex]
    return (arr3 = finalArr)
  } else {
    let finalArr = [arr.length - parseInt(params.perPage), arr.length]
    return (arr3 = finalArr)
  }
}

const ExportConfigDataListReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case "GET_CONNECTOR_DATA":
      return {
        ...state,
        data: action.data,
        // totalPages: action.totalPages,
        params: action.params,
        sortIndex: getIndex(
          state.allData,
          action.data,
          state.sortIndex,
          action.params
        )
      }
    case "GET_ALL_CONNECTOR_DATA":
      return {
        ...state,
        allData: action.data,
        totalRecords: action.data.length,
        // sortIndex: getIndex(action.data, state.data, state.sortIndex)
      }
    case "OPEN_MODEL_WORKQUEUE":
      return {
        ...state,
        modalWorkqueue: action.value,
      }
    case "OPEN_MODEL_GDRIVE_SUCCESS":
      return {
        ...state,
        modalGdriveSuccess: action.value,
      }
    case "OPEN_MODEL_UNAUTHENTICATED":
      return {
        ...state,
        modalUnauthenticated: action.value,
      }
    case "OPEN_MODEL_NOT_ACTIVE":
      return {
        ...state,
        modalNotActive: action.value,
      }
    case "OPEN_MODEL_MAIL_FAILURE":
      return {
        ...state,
        modalMailFailureExport: action.value,
      }
    case "OPEN_MODEL_EMAIL":
      return {
        ...state,
        modalEmail: action.value,
      }
    case "OPEN_MODEL_EMAIL_FAILED":
      return {
        ...state,
        modalEmailFailed: action.value,
      }
    case "OPEN_MODEL":
      return {
        ...state,
        modalData: action.value,
      }
    case "FILTER_CONNECTOR_DATA":
      let value = action.value
      let filteredData = []
      if (value.length) {
        filteredData = state.allData
          .filter(item => {
            let startsWithCondition =
              item.connectorName.toLowerCase().startsWith(value.toLowerCase()) ||
              item.connectorType.toLowerCase().startsWith(value.toLowerCase()) ||
              item.workspaceName.toLowerCase().startsWith(value.toLowerCase())

            let includesCondition =
              item.connectorName.toLowerCase().includes(value.toLowerCase()) ||
              item.connectorType.toLowerCase().includes(value.toLowerCase()) ||
              item.workspaceName.toLowerCase().startsWith(value.toLowerCase())

            if (startsWithCondition) {
              return startsWithCondition
            } else if (!startsWithCondition && includesCondition) {
              return includesCondition
            } else return null
          })
          .slice(state.params.page - 1, state.params.perPage)
        return { ...state, filteredData }
      } else {
        filteredData = state.data
        return { ...state, filteredData }
      }
    case "ADD_CONNECTOR_DATA":
      // let id = state.data.slice(-1)[0].id + 1
      state.data.push({
        ...action.obj,
        // id,
      })
      // moveIndex(
      //     state.data,
      //     state.data.findIndex(item => item.id === id),
      //     0
      // )
      return {
        ...state,
        data: state.data,
        totalRecords: state.allData.length,
        addResponse: action.data,
        // sortIndex: getIndex(state.allData, state.data, state.sortIndex),
      }
    case "UPDATE_CONNECTOR_DATA":
      state.data.find(item => {
        if (item.id === action.obj.id) {
          return Object.assign(item, {
            ...action.obj
          }
          )
        } else {
          return item
        }
      })
      return { ...state, updateResponse: action.data }
    case "DELETE_CONNECTOR_DATA":
      let index = state.data.findIndex(item => item.id === action.obj.id)
      let updatedData = [...state.data]
      updatedData.splice(index, 1)
      return {
        ...state,
        data: updatedData,
        totalRecords: state.allData.length,
        sortIndex: getIndex(
          state.allData,
          state.data,
          state.sortIndex,
          state.params
        )
      }
    case "TEST_GDRIVE_CONNECTION":
      return {
        ...state,
        testGdriveRes: action.data,
      }
    case "TEST_EMAIL_CONNECTION":
      return {
        ...state,
        testEmailRes: action.data,
      }
    case "MAKE_TOGGLE_ACTIVE":
      return {
        ...state,
        isActive: action.data,
        refresh: window.location.reload(false)
      }
    case "CONNECTOR_NAME_CHECK":
      return {
        ...state,
        connectorNameRes: action.data
      }

    case "SET_TABLE_LOADING":
      return {
        ...state,
        tableLoading: payload
      }
    case "SET_SIDEBAR_LOADING":
      return {
        ...state,
        sidebarLoading: payload
      }

    default:
      return state
  }
}

export default ExportConfigDataListReducer
